import { Verse } from './types';

export const courageVerses: Verse[] = [
  {
    text: "Have I not commanded you? Be strong and courageous. Do not be afraid; do not be discouraged, for the Lord your God will be with you wherever you go.",
    reference: "Joshua 1:9",
    why: "This verse reminds us that God's presence empowers us to face challenges with courage and strength."
  },
  {
    text: "The Lord is my light and my salvation—whom shall I fear? The Lord is the stronghold of my life—of whom shall I be afraid?",
    reference: "Psalm 27:1",
    why: "This verse reassures us that God is our protector, removing the need for fear."
  },
  {
    text: "For the Spirit God gave us does not make us timid, but gives us power, love, and self-discipline.",
    reference: "2 Timothy 1:7",
    why: "This verse reminds us that God's Spirit equips us with courage, love, and discipline."
  },
  {
    text: "Be on your guard; stand firm in the faith; be courageous; be strong.",
    reference: "1 Corinthians 16:13",
    why: "This verse calls us to remain steadfast and courageous in our faith."
  },
  {
    text: "When I am afraid, I put my trust in you.",
    reference: "Psalm 56:3",
    why: "This verse teaches us to trust in God when fear arises, replacing fear with courage."
  },
  {
    text: "Even though I walk through the darkest valley, I will fear no evil, for you are with me; your rod and your staff, they comfort me.",
    reference: "Psalm 23:4",
    why: "This verse reminds us that God's presence brings comfort and courage in our darkest moments."
  },
  {
    text: "So do not fear, for I am with you; do not be dismayed, for I am your God. I will strengthen you and help you; I will uphold you with my righteous right hand.",
    reference: "Isaiah 41:10",
    why: "This verse assures us of God's strength and support, encouraging us to face challenges fearlessly."
  },
  {
    text: "Be strong and take heart, all you who hope in the Lord.",
    reference: "Psalm 31:24",
    why: "This verse connects hope in God with the courage to persevere."
  },
  {
    text: "But now, this is what the Lord says—He who created you, Jacob, He who formed you, Israel: 'Do not fear, for I have redeemed you; I have summoned you by name; you are mine.'",
    reference: "Isaiah 43:1",
    why: "This verse reassures us that we belong to God, giving us courage to face any situation."
  },
  {
    text: "The Lord Himself goes before you and will be with you; He will never leave you nor forsake you. Do not be afraid; do not be discouraged.",
    reference: "Deuteronomy 31:8",
    why: "This verse reminds us that God's constant presence removes fear and discouragement."
  },
  {
    text: "Wait for the Lord; be strong and take heart and wait for the Lord.",
    reference: "Psalm 27:14",
    why: "This verse encourages patience and courage while trusting in God's timing."
  },
  {
    text: "Peace I leave with you; my peace I give you. I do not give to you as the world gives. Do not let your hearts be troubled and do not be afraid.",
    reference: "John 14:27",
    why: "This verse highlights the peace Jesus provides, enabling us to face fear with courage."
  },
  {
    text: "I sought the Lord, and He answered me; He delivered me from all my fears.",
    reference: "Psalm 34:4",
    why: "This verse reassures us that seeking God can free us from fear."
  },
  {
    text: "Cast your cares on the Lord and He will sustain you; He will never let the righteous be shaken.",
    reference: "Psalm 55:22",
    why: "This verse invites us to trust God with our burdens, knowing He will sustain us."
  },
  {
    text: "In God, whose word I praise—in God I trust and am not afraid. What can mere mortals do to me?",
    reference: "Psalm 56:4",
    why: "This verse highlights the protection and courage that come from trusting in God."
  },
  {
    text: "For the Lord will be your confidence and will keep your foot from being caught.",
    reference: "Proverbs 3:26",
    why: "This verse reminds us that confidence in the Lord prevents us from falling into fear."
  },
  {
    text: "The wicked flee though no one pursues, but the righteous are as bold as a lion.",
    reference: "Proverbs 28:1",
    why: "This verse compares the boldness of the righteous to the courage of a lion."
  },
  {
    text: "Be strong and courageous, because you will lead these people to inherit the land I swore to their ancestors to give them.",
    reference: "Joshua 1:6",
    why: "This verse reminds us that God equips us with courage to fulfill His promises."
  },
  {
    text: "Do not fear, for I have redeemed you; I have summoned you by name; you are mine.",
    reference: "Isaiah 43:1",
    why: "This verse reassures us of our worth and God's protection, inspiring courage."
  },
  {
    text: "Finally, be strong in the Lord and in His mighty power.",
    reference: "Ephesians 6:10",
    why: "This verse emphasizes relying on God's power for strength and courage."
  },
  {
    text: "Though an army besiege me, my heart will not fear; though war break out against me, even then I will be confident.",
    reference: "Psalm 27:3",
    why: "This verse shows unwavering courage in the face of overwhelming opposition."
  },
  {
    text: "Blessed is the one who trusts in the Lord, whose confidence is in Him.",
    reference: "Jeremiah 17:7",
    why: "This verse connects trust in God to a courageous and blessed life."
  },
  {
    text: "Do not let your hearts be troubled. You believe in God; believe also in me.",
    reference: "John 14:1",
    why: "This verse encourages faith in Christ as a source of courage and calm."
  },
  {
    text: "I can do all this through Him who gives me strength.",
    reference: "Philippians 4:13",
    why: "This verse reminds us that God's strength enables us to face any challenge."
  },
  {
    text: "The Lord is my helper; I will not be afraid. What can mere mortals do to me?",
    reference: "Hebrews 13:6",
    why: "This verse reassures us of God's help, eliminating fear of human threats."
  },
  {
    text: "Do not be afraid of them; the Lord your God Himself will fight for you.",
    reference: "Deuteronomy 3:22",
    why: "This verse assures us that God fights for us, so we have nothing to fear."
  },
  {
    text: "He gives strength to the weary and increases the power of the weak.",
    reference: "Isaiah 40:29",
    why: "This verse shows that God strengthens us in times of weakness, fostering courage."
  },
  {
    text: "But now, this is what the Lord says: Do not fear, for I have redeemed you; I have summoned you by name; you are mine.",
    reference: "Isaiah 43:1",
    why: "This verse reassures us of our identity in God, replacing fear with courage."
  }
];
